import { render, staticRenderFns } from "./ImgxSrcSet.vue?vue&type=template&id=50c98754&scoped=true&"
import script from "./ImgxSrcSet.vue?vue&type=script&lang=js&"
export * from "./ImgxSrcSet.vue?vue&type=script&lang=js&"
import style0 from "./ImgxSrcSet.vue?vue&type=style&index=0&id=50c98754&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50c98754",
  null
  
)

export default component.exports